(function () {

    'use strict';

    angular.module('iplusjs.validator.banned', [
        'lodash',
        'iplusjs.utils.misc',
        'iplusjs.utils.format',
        'iplusjs.fieldset'
    ])
        .directive('iplusjsBannedValidator', bannedValidator);

    bannedValidator.$inject = [
        'lodash',
        'FormatUtilsService',
        'MiscUtilsService'
    ];
    function bannedValidator(_, FormatUtilsService, MiscUtilsService) {
        return {
            restrict: 'A',
            require: ['ngModel', '^?iplusjsFieldset'],
            priority: 2000,
            link: linkFnc
        };

        function linkFnc($scope, $elem, $attrs, ctrls) {
            var $ngModel = ctrls[0],
                fieldsetCtrl = ctrls[1],
                banned = MiscUtilsService.isNotEmpty($attrs.iplusjsBannedValidator) ? $attrs.iplusjsBannedValidator.split(',') : null,
                allowed = MiscUtilsService.isNotEmpty($attrs.ibvAllowed) ? $attrs.ibvAllowed.split(',') : null,
                compareProp = $attrs.ibvCompareProp;

            if ($attrs.disabled || $scope.$eval($attrs.ngDisabled) || (fieldsetCtrl && fieldsetCtrl.disabled)) {
                return;
            }

            $attrs.$observe('iplusjsBannedValidator', function (bl) {
                var newBanned = MiscUtilsService.isNotEmpty(bl) ? bl.split(',') : null;

                if (!_.isEqual(banned, newBanned)) {
                    banned = newBanned;
                    $ngModel.$validate();
                }
            });

            $attrs.$observe('ibvAllowed', function (al) {
                var newAllowed = MiscUtilsService.isNotEmpty(al) ? al.split(',') : null;

                if (!_.isEqual(allowed, newAllowed)) {
                    allowed = newAllowed;
                    $ngModel.$validate();
                }
            });

            function isValid(value) {
                var val = value;

                if (MiscUtilsService.isEmpty(val)) {
                    return true;
                }

                if (_.isBoolean(value)) {
                    val = FormatUtilsService.toBooleanString(value);
                } else if (compareProp) {
                    val = _.get(value, compareProp);
                } else {
                    val = MiscUtilsService.getValueCustomObject(value);
                }

                if (_.isBoolean(val)) {
                    val = FormatUtilsService.toBooleanString(val);
                }

                if (!_.isEmpty(val) && (banned || _.size(banned) > 0)) {
                    return banned.indexOf(val) === -1;
                } else if (!_.isEmpty(val) && (allowed || _.size(allowed) > 0)) {
                    return allowed.indexOf(val) !== -1;
                }

                return true;
            }

            $ngModel.$validators.banned = function (value) {
                return isValid(value);
            };
        }
    }
})();
